<template>
  <div
    class="grid auto-rows-fr gap-4"
    :class="{
      'grid-cols-[repeat(auto-fill,minmax(10rem,1fr))]': size === 'extra-small',
      'grid-cols-[repeat(auto-fill,minmax(12rem,1fr))]': size === 'small',
      'grid-cols-[repeat(auto-fill,minmax(14rem,1fr))]': size === 'medium',
      'grid-cols-[repeat(auto-fill,minmax(18rem,1fr))]': size === 'large'
    }"
  >
    <label
      v-for="option in options"
      :key="option[trackBy]"
      :data-tint="tinted ? option.color : undefined"
      class="squircle-lg relative block cursor-pointer overflow-hidden rounded-lg border bg-white select-none"
      :class="{
        'bg-primary-50': !colorfull && !modelValue?.includes(option[trackBy]),
        'bg-primary-50': colorfull && !modelValue?.includes(option[trackBy]),
        'border-primary bg-primary-50':
          !colorfull && modelValue?.includes(option[trackBy]),
        'border-primary bg-primary text-contrast-primary':
          colorfull && modelValue?.includes(option[trackBy]),
        'p-1': size === 'extra-small',
        'p-2': size === 'small',
        'p-3': size === 'medium',
        'cursor-pointer': editionMode,
        'cursor-not-allowed': !editionMode,
        'pointer-events-none': !editionMode
      }"
    >
      <div
        v-if="option.icon"
        class="absolute right-2 opacity-50"
        :class="{
          'text-primary-500':
            (!colorfull && modelValue?.includes(option[trackBy])) ||
            (!colorfull && !modelValue?.includes(option[trackBy])) ||
            (colorfull && !modelValue?.includes(option[trackBy])),
          'text-primary-50': colorfull && modelValue?.includes(option[trackBy]),

          'bottom-2': option?.description?.length,
          'inset-y-0 flex items-center': !option?.description?.length
        }"
      >
        <FontAwesomeIcon
          :icon="
            Array.isArray(option.icon) ? option.icon : ['fal', option.icon]
          "
          :size="size === 'medium' ? '2x' : 'lg'"
          fixed-width
        />
      </div>
      <div
        class="flex flex-row gap-1.5"
        :class="{
          'items-start': option.description?.length > 0,
          'items-center': !(option.description?.length > 0)
        }"
      >
        <div
          class="shrink-0"
          :class="{
            'pt-0.5': option.description?.length > 0,
            flex: !(option.description?.length > 0)
          }"
        >
          <input
            v-model="localModelValue"
            type="checkbox"
            :value="option[trackBy]"
            class="text-primary rounded focus:ring-0 focus:ring-offset-0 active:ring-0 active:ring-offset-0"
            :class="{
              'text-primary': !colorfull,
              'text-primary-300': colorfull
            }"
            :disabled="!editionMode"
          />
        </div>
        <div class="flex flex-1 flex-col">
          <h3
            class="leading-tight font-semibold"
            :class="{
              'text-base': size === 'medium',
              'text-xs': size === 'small',
              'text-xxs': size === 'extra-small'
            }"
          >
            {{ option[attributeLabel] }}
          </h3>
          <p class="text-xs empty:hidden">{{ option.description }}</p>
          <slot name="extra" :option="option" />
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'CheckBoxCardsComponent',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    trackBy: {
      type: String,
      required: false,
      default: 'value'
    },
    attributeLabel: {
      type: String,
      required: false,
      default: 'label'
    },
    tinted: {
      type: Boolean,
      required: false,
      default: false
    },
    colorfull: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
